export const ActivityStatusConstants = {
    ACKNOWLEDGED: 'CCF7B170-FFFB-497E-B41D-3D0703070DEB'.toLowerCase(),
    APPROVED_WITH_FEEDBACK: 'E02992FF-DAED-4B91-9AAE-4B77994FDC4D'.toLowerCase(),
    PENDING_UPDATED: '2DD397A0-F819-4418-977D-4A89B21897A4'.toLowerCase(),
    APPROVED: '04FA81FE-CBBC-4B16-8FFD-B03732BCD20B'.toLowerCase(),
    DECLINED: '935EDD1D-5709-4A44-AEDE-FFC292860A84'.toLowerCase(),
    OUTSTANDING: '41A5401A-BF91-4A1E-91EF-B76420C07292'.toLowerCase(),
    REVIEWED_WITH_FEEDBACK: '0A42EE95-05A8-44E7-86B4-8923CE146057'.toLowerCase(),
    PENDING: '78A3E8AE-77CD-4CFF-9A7E-12025DF14552'.toLowerCase(),
}